<template>
  <el-dialog
    title="渠道变更"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <div style="padding: 20px 0; text-align: center;">
      <el-select
        v-model="channelName"
        filterable
        remote
        reserve-keyword
        placeholder="请输入关键字搜索"
        :remote-method="getChannelList"
        :loading="channelLoading"
        style="width: 80%"
        @change="handleChannelChange"
      >
        <el-option
          v-for="item in channelOptions"
          :key="item.id"
          :label="item.realname ? item.realname + '(' + item.alias + ')' : item.alias"
          :value="item.realname"
        >
        </el-option>
      </el-select>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getChannelList, updatePaGxbUser } from '@/api/member'

export default {
  name: 'ChangeChannel',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    currentUser: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      channelLoading: false,
      submitting: false,
      channelName: '',
      channelId: '',
      channelOptions: [],
      allChannels: []
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 初始化数据
    initData() {
      this.channelName = ''
      this.channelId = ''
      this.getChannelList()
    },

    // 获取渠道列表
    getChannelList(query) {
      // 如果没有用户或用户没有平台ID，不获取渠道列表
      if (!this.currentUser || !this.currentUser.app_id) {
        // 如果currentUser存在但没有app_id，尝试使用userId获取用户信息
        this.channelOptions = []
        return
      }
      
      const params = {
        app_id: this.currentUser.app_id
      }
      
      this.channelLoading = true
      getChannelList(params).then(res => {
        if (res && res.err_code === 0) {
          this.allChannels = res.rows || []
          
          if (query) {
            this.channelOptions = (res.rows || []).filter(item => {
              const name = item.name || ''
              const alias = item.alias || ''
              const searchStr = name + alias
              return searchStr.toLowerCase().includes(query.toLowerCase())
            })
          } else {
            this.channelOptions = res.rows || []
          }
        }
      }).catch(error => {
        console.error('获取渠道列表失败:', error)
        this.$message.error('获取渠道列表失败')
      }).finally(() => {
        this.channelLoading = false
      })
    },

    // 渠道选择变化
    handleChannelChange(val) {
      // 设置选中的渠道名称
      this.channelName = val
      
      // 重置渠道ID
      this.channelId = ''
      
      if (val) {
        const selectedChannel = this.allChannels.find(channel => 
          (channel.realname && channel.realname === val) || 
          (!channel.realname && channel.realname === val)
        )
        if (selectedChannel) {
          this.channelId = selectedChannel.id
        }
      }
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      if (!this.channelName || !this.channelId) {
        this.$message.warning('请选择渠道')
        return
      }
      
      this.submitting = true
      const params = {
        user_id: Number(this.userId),
        channel_id: Number(this.channelId)
      }
      
      updatePaGxbUser(params).then(res => {
        if (res && res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('success')
          this.handleClose()
        } else {
          this.$message.error((res && res.err_msg) || '保存失败')
        }
      }).catch(error => {
        console.error('变更渠道失败:', error)
        this.$message.error('保存失败')
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>